const AUTH = 'auth';
const USER = 'user';
const ERROR = 'error';
const USERROLE = 'userRole';
const LANGUAGE = 'language';
const DIGIREGMAN = 'digiRegman';
const EVENTREGISTRATION = 'eventRegistration';
const ORGANIZATION = 'organization';

export default {
	AUTH,
	USER,
	ERROR,
	USERROLE,
	LANGUAGE,
	DIGIREGMAN,
	EVENTREGISTRATION,
	ORGANIZATION,
};
